import { useEffect, useState } from "react";
import updated_logo from "@/assets/logo/logo.png";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react"; // Lucide icons for hamburger and close

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 py-8 ${
        scrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      <div className="w-full flex items-center justify-between px-[3vw]">
        <Link to="/" className="flex items-center">
          <img src={updated_logo} alt="logo" className="h-10" />
        </Link>

        {/* Hamburger */}
        <button
          className="md:hidden text-black focus:outline-none"
          onClick={toggleMenu}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Menu Items */}
        <nav
          className={`${
            isOpen ? "block" : "hidden"
          } absolute top-full left-0 bg-white shadow-md md:shadow-none md:bg-transparent md:static md:flex md:items-center md:space-x-6 transition-all duration-300`}
        >
          <Link
            to="/"
            onClick={() => setIsOpen(false)}
            className="block px-6 py-3 md:p-0 hover:text-gray-600"
          >
            Home
          </Link>
          <Link
            to="/about-us"
            onClick={() => setIsOpen(false)}
            className="block px-6 py-3 md:p-0 hover:text-gray-600"
          >
            About Us
          </Link>
          <Link
            to="/services"
            onClick={() => setIsOpen(false)}
            className="block px-6 py-3 md:p-0 hover:text-gray-600"
          >
            Services
          </Link>
          <Link
            to="/blogs"
            onClick={() => setIsOpen(false)}
            className="block px-6 py-3 md:p-0 hover:text-gray-600"
          >
            Blog
          </Link>
          <Link
            to="/testimonials"
            onClick={() => setIsOpen(false)}
            className="block px-6 py-3 md:p-0 hover:text-gray-600"
          >
            Testimonials
          </Link>
          <Link
            to="/contact"
            onClick={() => setIsOpen(false)}
            className="block px-6 py-3 md:p-0 hover:text-gray-600"
          >
            Contact Us
          </Link>
        </nav>
      </div>
    </header>
  );
}
